<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" class="float-right" @click="$modal.show('create_location')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th>{{ $t('Main location') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(location, i) in locations" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ location.name[locale] }}</td>
                    <td>{{ location.main_location ? $t('Yes') : $t('No') }}</td>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_location', {location})" small>
                                {{ $t('Edit') }}
                            </app-button>
                            <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroy(location.id)" small>
                                {{ $t('Delete') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <create-modal @setLocation="setLocation"/>
        <update-modal @setLocation="setLocation"/>
    </div>
</template>

<script>
import LocationService from '@services/location.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import Vue from 'vue';

export default {
    data() {
        return {
            locations: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getLocations() {
            LocationService.locations().then(res => this.locations = res);
        },
        setLocation() {
            this.getLocations();
        },
        destroy(locationId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            LocationService.destroy(locationId).then(res => {
                this.getLocations();
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal
    },
    created() {
        this.getLocations();
    },
    metaInfo() {
        return {
            title: this.$t('Locations')
        };
    }
};
</script>
